import { render, staticRenderFns } from "./EquipItems.vue?vue&type=template&id=56ac892c"
import script from "./EquipItems.vue?vue&type=script&lang=js"
export * from "./EquipItems.vue?vue&type=script&lang=js"
import style0 from "./EquipItems.vue?vue&type=style&index=0&id=56ac892c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports